<template>
  <div>
    <div style="padding:0.3rem 1.5rem 1rem">
      <a-row>
        <a-col :span="11">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">中文名稱</div>
            <div class="border_cal">{{params.cn_name}}</div>
          </div>
        </a-col>
        <a-col :span="2"></a-col>
        <a-col :span="11">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">英文名稱</div>
            <div class="border_cal">{{params.en_name}}</div>
          </div>
        </a-col>
      </a-row>
      <a-row style="margin-top:0.5rem">
        <a-col :span="11">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">電話號碼</div>
            <div class="border_cal">{{params.nationcode}}&emsp;{{params.phonenum}}</div>
          </div>
        </a-col>
        <a-col :span="2"></a-col>
        <a-col :span="11">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">電郵地址</div>
            <div class="border_cal border_cal_over" :title="params.email">{{params.email}}</div>
          </div>
        </a-col>
      </a-row>
      <a-row style="margin-top:0.5rem">
        <a-col :span="11">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">身份信息</div>
            <div class="border_cal">{{params.id_number}}</div>
          </div>
        </a-col>
        <a-col :span="2"></a-col>
        <a-col :span="11">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">出生日期</div>
            <div class="border_cal">{{params.birth}}</div>
          </div>
        </a-col>
      </a-row>
      <a-row style="margin-top:0.5rem">
        <a-col :span="11">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">銀行名稱</div>
            <div class="border_cal">{{params.bank}}</div>
          </div>
        </a-col>
        <a-col :span="2"></a-col>
        <a-col :span="11">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">銀行號碼</div>
            <div class="border_cal">{{params.bank_number}}</div>
          </div>
        </a-col>
      </a-row>
      <a-row style="margin-top:0.5rem">
        <a-col :span="24">
          <div style="display:flex;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">地址信息</div>
            <div class="border_cal" style="height:3.5rem;align-items: normal;">{{params.address}}</div>
          </div>
        </a-col>
      </a-row>
    </div>
    <div style="border-top:1px solid #e5e5e5;display: flex;justify-content: end;padding: 1rem 1rem 0.6rem 0;">
      <div style="background:#f48d28; padding: 0.6rem 2rem;color:#fff;font-size: 0.8rem;cursor: pointer;" @click="nextFn()">下一頁</div>
    </div>
  </div>
</template>

<script>
export default {
  props:['isval','father'],
  data(){
			return {
        params:{},
        dividendsedit : this.$store.state.rolesdata.indexOf('dividendsedit') >= 0,
			}
		},
		mounted() {
      this.getQmisUserMsgWithUsername()
		},
		methods:{
      getQmisUserMsgWithUsername(){
        this.$ajax({
          method: "post",
          url: this.$api.getQmisUserMsgWithUsername,
          data: {
            username:this.isval.username
          },
        }).then((res) => {
          if (res.data.qmiscode == 1000) {
            this.params = res.data
          } else {
            App.oTool.warningT(res.data.qmismsg);
          }
        });
      },
      nextFn(){
        if (this.dividendsedit) {
          this.father.fanfn(1)
        }else{
          this.father.fanfn(2)

        }
      },
		
		}

}
</script>

<style>
  .border_cal{
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    width: 100%;
    height: 1.75rem;
    font-size: 0.8rem;
    padding: 4px 11px;
    display: flex;
    align-items: center;
    overflow: hidden;
  }
  .border_cal_over{
    word-break: break-all;
    white-space: normal;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
</style>
